import Icon from '@tiger/icons';
import { Button } from 'antd';
import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import BottomBox from 'components/BottomBox';
import ScrollTop from 'components/ScrollTop';
import { TaxLimitInfo } from 'modules/Deposit/type';
import { ReactComponent as write } from 'static/images/icons/edit.svg';
import waitingImg from 'static/images/icons/waiting.svg';
import './style.scss';
import ContributionSuccess from '../components/ContributionSuccess';

interface CompleteProps {
    type: 'wire' | 'check';
    isIRA?: boolean;
}

const Complete: FC<CompleteProps> = ({ isIRA, type }) => {
    const location = useLocation();
    // isIRA=true 时从 deposit/notice(FillNotice) 页面跳转过来，携带了税额限额信息
    const locationState = location.state as {
        tax: TaxLimitInfo;
    } | null;

    return (
        <div className="deposit-complete-root">
            <ScrollTop />
            {isIRA ? (
                <ContributionSuccess
                    year={locationState!.tax.year}
                    cost={locationState!.tax.cost}
                    className="mt-6 mb-7"
                    extra={
                        type !== 'check' ? null : (
                            <div className="text-muted">
                                {__(
                                    'Please note, your remaining contribution limit will not be adjusted until after your funds have settled.'
                                )}
                            </div>
                        )
                    }
                />
            ) : (
                <>
                    <img className="icon-waiting" src={waitingImg} alt="waiting" />
                    <div className="notice-message">
                        <h3>{__('等待汇款到账')}</h3>
                        <div className="desc">
                            {__('老虎已收到您的通知，实际到账速度取决于银行，通常需要1-4个工作日。')}
                        </div>
                        <div className="desc">{__('请您耐心等待，入金成功后，您会立刻收到通知。')}</div>
                    </div>
                </>
            )}
            <BottomBox className="w-100">
                <Link className="d-block w-100" to={type === 'check' ? '../check-notice' : '../notice'}>
                    <Button type="primary" className="btn-important">
                        <Icon className="icon-write" component={write} />
                        {__('继续上传')}
                    </Button>
                </Link>
                <Link className="check-record" to="../record">
                    {__('查看提交记录')}
                </Link>
            </BottomBox>
        </div>
    );
};

export default Complete;
